import React from "react";
import bgImage from "./../images/bg.jpg";

const Header = () => {
  return (
    <header className="py-5 mb-5" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          <div className="col-lg-12">
            <h1 className="display-4 text-white mt-5 mb-2">Leszek Czereba</h1>
            <p className="lead mb-5 text-white">
              Jesteśmy zakładem kamieniarskim z rodzinnymi tradycjami. Zdobywamy nowe rynki i cieszymy się wielkim
              uznaniem klientów. Wieloletnie doświadczenie pozwala naszej firmie w prosty sposób wykonywać powierzone
              nam zadania.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
